import { Chip } from 'components/Chip/Chip'
import { useSeededShuffle } from 'hooks/useSeededShuffle'
import { FeedbackChipProps } from './Types'

export const FeedbackChips = ({ feedback, onChipPress }: FeedbackChipProps) => {
  const seededShuffle = useSeededShuffle()

  return (
    <>
      {seededShuffle([
        <Chip
          variant="flat"
          deletable={false}
          key="layouts_and_templates"
          data-key="layouts_and_templates"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['layout_and_templates']}
        >
          Layouts and templates
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="colors_and_fonts"
          data-key="colors_and_fonts"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['colors_and_fonts']}
        >
          Colors and fonts
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="image_relevance"
          data-key="image_relevance"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['image_relevance']}
        >
          Image relevance
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="repeat_image"
          data-key="repeat_image"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['repeat_image']}
        >
          Repeat image
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="design_text"
          data-key="design_text"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['design_text']}
        >
          Design text
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="caption_text"
          data-key="caption_text"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['caption_text']}
        >
          Caption text
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="inaccurate"
          data-key="inaccurate"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['inaccurate']}
        >
          Inaccurate
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="amount_of_text"
          data-key="amount_of_text"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['amount_of_text']}
        >
          Amount of text
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="writing_quality"
          data-key="writing_quality"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['writing_quality']}
        >
          Writing quality
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="missing_text"
          data-key="missing_text"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['missing_text']}
        >
          Missing text
        </Chip>,
        <Chip
          variant="flat"
          deletable={false}
          key="wrong_language"
          data-key="wrong_language"
          onPress={onChipPress}
          isSelected={feedback.feedback?.['wrong_language']}
        >
          Wrong language
        </Chip>,
      ])}
      <Chip
        variant="flat"
        deletable={false}
        key="other"
        data-key="other"
        onPress={onChipPress}
        isSelected={feedback.feedback?.['other']}
      >
        Other
      </Chip>
    </>
  )
}
